 export enum AuthAccount {
   Central = 'central',
   MadCapID = 'madcap-id',
   SSO = 'sso'
 }
